import { ProFormColumnsType } from '@ant-design/pro-components';
import { FormattedMessage } from 'react-intl';

export const createTextFormItem = (
  itemKey: string,
  localeKey?: string,
  isRequired = true,
  isNumber?: boolean,
  min?: number,
): ProFormColumnsType =>
  ({
    title: <FormattedMessage id={`btlApplicationForm.TOP_SLICING_HOUSEHOLD.${localeKey}.${itemKey}.label`} />,
    dataIndex: [itemKey],
    width: isNumber ? 200 : undefined,
    valueType: isNumber ? 'digit' : 'text',
    formItemProps: {
      hasFeedback: isRequired,
      rules: [
        {
          required: isRequired,
          message: <FormattedMessage id={'common.error.requiredField'} />,
        },
        ...(min
          ? [{ type: 'number', min, message: <FormattedMessage id={'common.error.minNumber'} values={{ min }} /> }]
          : []),
      ],
    },
  } as ProFormColumnsType);

export const createNumberFormItem = (
  itemKey: string,
  localeKey?: string,
  min?: number,
  isRequired = true,
): ProFormColumnsType => createTextFormItem(itemKey, localeKey, isRequired, true, min);
